import React, { useState, useEffect } from 'react';
import { Link ,Routes,Route,Router,Switch, useNavigate, useHistory , useLocation } from 'react-router-dom';
import { formatDistanceToNow, parseISO } from 'date-fns';
import axios from 'axios';
import Header from './Header';
import Footer from './Footer';
const BASE_URL=process.env.REACT_APP_BASE_URL;
const BookMark = () => {
    const location = useLocation();
	const navigate = useNavigate();
	//const jobsData = sessionStorage.getItem('jobs');
	const [jobs, setJobs] = useState([]);
	const [filteredJobs, setFilteredJobs] = useState([]);
	const [minSalary, setMinSalary] = useState(0);
	const [maxSalary, setMaxSalary] = useState(300000);
	const [salary, setSalary] = useState(0);
	const [status, setStatus] = useState(null);
	const [locations, setLocations] = useState([]);
	const [designations, setDesignations] = useState([]);
	const [minExperience, setMinExperience] = useState(0);
	const [maxExperience, setMaxExperience] = useState(25);
	const [experience, setExperience] = useState(1);
	const [candidate, setCandidate] = useState(0);
	const [prime, setPrime] = useState([]);
	const [jobDetails, setJobDetails] = useState([]);
	const [jobid, setJobid] = useState('');
	useEffect(() => {
		axios
        .get(`${BASE_URL}getprimeJobs`)        
        .then((response) => {
         // alert(JSON.stringify(response.data));
         setPrime(response.data);
        })
        .catch((error) => {
          console.error('Error fetching data:', error);
        });
	}, []);
	useEffect(() => {
		// Retrieve jobs from sessionStorage
		const jobsData = sessionStorage.getItem('jobdetails');
		const candi= sessionStorage.getItem('candidateId');
		if(candi)
		{
			setCandidate(candi);
		}
		if (jobsData) {
		  try {
			// Parse the jobs data and set it to the state
			const parsedJobs = JSON.parse(jobsData);
			setJobDetails(parsedJobs);
			//console.log(parsedJobs); 
			setJobid(parsedJobs[0].jobidd);
		  } catch (error) {
			console.error('Error parsing jobs data:', error);
		  }
		}
	  }, []);
	  useEffect(() => {
		if(candidate){
		axios
        .get(`${BASE_URL}getmyJobs?candidateId=${candidate}`)        
        .then((response) => {
		if (response.data && response.data.length > 0) {
         setPrime(response.data);
		}
        })
        .catch((error) => {
          console.error('Error fetching data:', error);
        });
	}
	}, [candidate]);
	useEffect(() => {
		// Retrieve jobs from sessionStorage
		const jobsData = sessionStorage.getItem('jobs');
		const candi= sessionStorage.getItem('candidateId');
		if(candi)
		{
			setCandidate(candi);
            axios
                .get(`${BASE_URL}bookmark-jobs?candidateId=${candi}`)
                    .then(response => {
                        console.log("mymydata");
                        console.log(JSON.stringify(response.data.applied));
                        setJobs(response.data.applied);
                    })
                    .catch(error => {
                        console.error("There was an error fetching the data!", error);
                    });
		}
		
	  }, []);
	  useEffect(() => {
		const filtered = jobs.filter(job => job.minbasicsalary >= salary);
		setFilteredJobs(filtered);
	  }, [minSalary, maxSalary, jobs]);
	useEffect(() => {
		axios.get(`${BASE_URL}distinct-data`)
		  .then(response => {
			console.log(JSON.stringify(response.data));
			setLocations(response.data.locations);
			setDesignations(response.data.designations);
			setMinExperience(response.data.minExperience);
			setMaxExperience(20);
			setExperience(response.data.minExperience);
		  })
		  .catch(error => {
			console.error("There was an error fetching the data!", error);
		  });
	  }, []);
	
 const handleSalaryChange = (e) => {
		const newSalary = parseFloat(e.target.value);
		const filtered = jobs.filter(job => job.minbasicsalary >= newSalary);
		setFilteredJobs(filtered);
		setSalary(newSalary);
	  };
 const filterJobs = (status) => {
		if (status === 'all') {
		  setFilteredJobs(jobs);
		} else {
		  const filtered = jobs.filter(job => job.applicationstatus === status);
		  setFilteredJobs(filtered);
		}
	  };

 const [selectedLocation, setSelectedLocation] = useState(null);
 const [selectedDesignation, setSelectedDesignation] = useState(null);
  const handleLocationChange = (event) => {
    setSelectedLocation(event.target.value);
    console.log('Selected location ID:', event.target.value);
  };
  const handleDesignationChange = (event) => {
    setSelectedDesignation(event.target.value);
    console.log('Selected Designation ID:', event.target.value);
  };
  useEffect(() => {
	if (selectedDesignation) {
		
		axios
		  .get(`${BASE_URL}distinct-location?designation=${selectedDesignation}`)
	  .then(response => {
		console.log(JSON.stringify(response.data));
		setLocations(response.data.locations);
	  })
	  .catch(error => {
		console.error("There was an error fetching the data!", error);
	  });
	}
  }, [selectedDesignation]);
	  const handleButtonClick = async (e) => {
		e.preventDefault();
	
		const formData={
			skill: selectedDesignation,  // Changed from 'skils' to 'skill'
			location: selectedLocation,
			exp: experience,
			candidateId: sessionStorage.getItem("candidateId") || ""
		}
		//alert(JSON.stringify(formData));
		console.log('Submitting form data:', formData);  // For debugging
		
		try {
		 //  const response = await fetch('http://localhost:8000/api/getJobs', {
			const response = await fetch(`${BASE_URL}getJobs`, {
		
			method: 'POST',
			headers: {
			  'Content-Type': 'application/json'
			},
			body: JSON.stringify(formData)
		  });
	  
		  if (response.ok) {
			setStatus(response.status);
			const data = await response.json();
			sessionStorage.setItem('jobs', JSON.stringify(data));
			const jobsData = sessionStorage.getItem('jobs');
			//setJobs(JSON.parse(jobsData));
			navigate('/jobsearch', { state: { response: data } });
		  } else {
			setStatus(response.status);
			console.error('Failed to submit form');
		  }
		} catch (error) {
		  console.error('Error submitting form', error);
		}
	  };
	const calculateDaysAgo = (dateString) => {
		if (!dateString) {
		  return "Invalid date";
		}
	  
		try {
		  const postedDate = parseISO(dateString);
		  return formatDistanceToNow(postedDate, { addSuffix: true });
		} catch (error) {
		  console.error("Error parsing date:", error);
		  return "Invalid date..";
		}
	  };
	  function formatDate(dateString) {
		const date = new Date(dateString);
		const day = date.getDate();
		const month = date.toLocaleString('default', { month: 'long' });
		const year = date.getFullYear();
	  
		// Get the ordinal suffix for the day (e.g., 1st, 2nd, 3rd, etc.)
		const getOrdinalSuffix = (day) => {
		  if (day > 3 && day < 21) return 'th'; // for 11th, 12th, 13th, etc.
		  switch (day % 10) {
			case 1: return 'st';
			case 2: return 'nd';
			case 3: return 'rd';
			default: return 'th';
		  }
		};
	  
		return `${day}${getOrdinalSuffix(day)} ${month} ${year}`;
	  } 
	  
	
	  const handleClick = async (e,idd,desigid) => {
	
		e.preventDefault();
		//alert(idd);
	//alert(JSON.stringify(formData));

	const formData={
		jobId: idd,
		designationId: desigid,
		candidateId:candidate
	  };
	//  alert(JSON.stringify(formData));
		try {
			
		  //const response = await fetch('http://localhost:8000/api/getJobDetails', {
		  const response = await fetch(`${BASE_URL}getJobDetails`, {
			
		 	method: 'POST',
		 	headers: {
		 	  'Content-Type': 'application/json'
		 	},
			 body: JSON.stringify(formData)
		   });
		   if (response.ok) {
		
		 	const data = await response.json();
			 sessionStorage.setItem('jobdetails', JSON.stringify(data));
			navigate('/jobdetails', { state: { response: data } });
			
		   } else {
		 	console.error('Failed to submit form');
		   }
		} catch (error) {
		  console.error('Error submitting form', error);
		}
	  };
      const statusMapping = {
        0: 'Pending',
        1: 'Viewed',
        2: 'Notified',
        3: 'Accepted',
        4: 'Rejected',
        5: 'Shortlisted'
      };
	  const concatenateStrings = (str1, str2, str3) => {
		// Filter out falsy values like null, undefined, or empty string
		const parts = [str1, str2, str3].filter(part => part !== null && part !== 'null' && part !== undefined && part !== '');

		//alert(parts);
		return parts.join('/');
	  };
	const renderResponse = () => {
		if (status === 404) {
			return <div>No job openings found..</div>;
		  }
		if (Array.isArray(filteredJobs)) {
		  return filteredJobs.map((item, index) => (
			<div key={index}>
			 
			  <div className="card mb-3">
						<div className="card-body jobsearchview">
                        <a href="javascript:void(0);" onClick={(e) => handleClick(e, item.jobidd,item.designationid)}>
							<div className="row">
								<div className="col-lg-12">
									
									<h4>{item.designation}</h4>
									{item.flag_emp === 1 && (
									 <h5 className="mb-3">{item.companyname}</h5>
									  )}
									
									<div className="deatilssec"><span className="pe-3"><i className="fa fa-briefcase" aria-hidden="true"></i> {item.minimumexperince} - {item.maximumexperince} years of experience - {item.industryname}  </span> | <span className="pe-3"> {item.currency} {item.minbasicsalary} in {item.maxbasicsalary} /Month </span> |  <span className="pe-3"> <i className="fa fa-map-marker" aria-hidden="true"></i>{item.location_name}
                                    </span></div>
									{/* <div className="deatilssec"><span className="pe-3"><i className="fa fa-thumb-tack" aria-hidden="true"></i>{concatenateStrings(`${item.requiredqualification1}`,`${item.requiredqualification2}`,`${item.requiredqualification3}`)} </span></div> */}
									<div className="deatilssec"><span className="pe-3"><i className="fa fa-bookmark" aria-hidden="true"></i><span >Applied on: {formatDate(`${item.created_at}`)} | Acknowledge Number : {item.acknowledge_no} </span> </span></div>
									<div className="deatilssec"><span className="pe-3"><i className="fa fa-bookmark" aria-hidden="true"></i><span >Application Status: {statusMapping[item.applicationstatus]}</span> </span></div>
									
								</div>
								
							</div>
							<div className="row mt-3">
								<div className="col-lg-6">
								<h5>Posted On: {formatDate(`${item.posteddate}`)}  | Openings: {item.numberofposts} </h5>
								</div>
								<div className="col-lg-6 text-right">
									<small className="pe-3"> <i className="fa fa-bookmark-o" aria-hidden="true"> </i> View Details</small>
								</div>
							</div>
							</a>
						</div>
					</div>
			</div>
		  ));
		}  else {
		  return <p>Invalid data format received</p>;
		}
	  };
	  const vertic={
		maxHeight: '300px', 
		overflowY:'scroll',  
		padding: '10px', 

	  }
  return (
    <div>
        <Header />
        <section className="practise-part section-p bg-light">
        <div className="container">
			<div className="row">
			    
				<div className="col-lg-8">
				<div class="row mb-3 justify-content-space-between align-items-center">
					<div class="col-lg-8">
						<h3>Applied Jobs List</h3>
					</div>
					{/* <div class="col-lg-8 float-end text-end text-right">
						<button  onClick={() => filterJobs('all')}  class="btn text-dark border-1 p-2 btn-1 me-2">All</button>
						<button  onClick={() => filterJobs(0)}  class="btn text-dark border-1 p-2 btn-1 me-2">Pending</button>
						<button  onClick={() => filterJobs(5)} class="btn text-dark border-1 p-2 btn-1 me-0">Shortlisted</button>
					</div> */}
				</div>


{jobs ? (
        <div>

          {renderResponse()}
        </div>
      ) : (
        <p>No data received</p>
      )}

					

{/* {response ? (
        <div>
          <h2>Data received:</h2>
          <pre>{JSON.stringify(response, null, 2)}</pre>
        </div>
      ) : (
        <p>No data received</p>
      )}  */}
					
					
				</div>
				<div className="col-lg-4">
					<div className="card mb-3">
						<div className="card-body">
						<h4 className="mb-2">Jobs that might interest you</h4>
<div className="facet-wrapper1" data-facet="district" >
{prime.length > 0 ? (
    <div className="row">
        {prime.map((job, index) => (
            <div key={index} className="col-12" style={{ paddingBottom: "20px" }}>
                <a href="javascript:void(0);" onClick={(e) => handleClick(e, job.id, job.designationid)}>
                    <div className="row">
                        <div className="col-lg-12">
                            <h5>{job.designation}</h5>
                            <div className="details-sec">
                                <span className="pe-3">
                                    <i className="fa fa-map-marker" aria-hidden="true"></i>&nbsp;
                                    {job.location_name}
                                </span>
                            </div>
                            <small>
                                Posted On {formatDate(`${job.posteddate}`)} <br /> Openings: {job.numberofposts}
                            </small>
                        </div>
                    </div>
                </a>
                <hr />
            </div>
        ))}
    </div>
) : (
    <p>No jobs available.</p>
)}

</div>
							
						</div>
					</div>
					
					
					
					
				
				
				
				</div>
			</div>
		</div>
    </section>
    <Footer />
    </div>
  )
}


export default BookMark